export default __webpack_public_path__ + "static/media/replace-starter-selected.47d6ab87.svg";